import { DateTime } from 'luxon'
import { IDeadline } from 'shared/Modules/Product/productTypes'
import { ReactLocalization } from "@fluent/react/esm/localization"

export const ISO_DATE_FORMAT = 'yyyy-MM-dd'
export const ISO_TIME_FORMAT = 'HH:mm:ss'
export const ISO_TIME_MINUTE_FORMAT = 'HH:mm'
export const ISO_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss'

type HourCycle = "h11" | "h12" | "h23" | "h24" | undefined

export function getIsoDatesBetween(start: string, end: string): string[] {
    let dates = []

    let currentDate = DateTime.fromFormat(start, ISO_DATE_FORMAT)
    while (currentDate.toISODate() !== end) {
        dates.push(currentDate.toISODate())
        currentDate = currentDate.plus({ days: 1 })
    }

    dates.push(end)

    return dates
}

function capitalize (text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1)
}

export function toWeekDay(dateTime: DateTime) {
    return capitalize(dateTime.toFormat("cccc"))
}

export function isPastDeadline (deadline: IDeadline, isoDate: string) {
    const now = DateTime.local()
    const orderDate = DateTime.fromISO(`${isoDate}T${deadline.timeOfDay}`)
    const deadlineDate = orderDate.minus({ days: deadline.inDays })
    return now > deadlineDate
}

function isHourCycle(value: string | undefined): value is HourCycle {
    switch (value) {
        case "h11":
        case "h12":
        case "h23":
        case "h24":
            return true
        default:
            return false
    }
}

export const getAmPm = (l10n: ReactLocalization, locale: string): boolean => {
    const hourCycleRaw = l10n.getString("date-time-hour-cycle")
    const hourCycle = isHourCycle(hourCycleRaw) ? hourCycleRaw : undefined
    const loc = new Intl.DateTimeFormat(locale, { hour: "numeric", hourCycle })
    return loc.resolvedOptions().hour12 ?? false
}
